export const eyes = [
    'Eye3', 'Eye2', 'Eye14', 'Eye4', 'Eye16',
    'Eye1', 'Eye11', 'Eye17', 'Eye15',
];
export const hair = [
    'Hair1', 'Hair2', 'Hair3', 'Hair4', 'Hair5', 'Hair6', 'Hair7',
    'Hair11', 'Hair12', 'Hair13', 'Hair14', 'Hair15', 'Hair16', 'Hair17', 'Hair18', 'Hair19',
];
export const mouths = [
    'Mouth1', 'Mouth2', 'Mouth3', 'Mouth4', 'Mouth5', 'Mouth7',
    'Mouth11', 'Mouth12', 'Mouth13', 'Mouth14',
];
